import styled, { css } from "styled-components";
import transparencyBg from "page/ui/Timer/asset/transparency.png";

const Style = {
    "Bg": styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #00000066;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    `,

    "Modal": styled.div`
        width: fit-content;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 40px;
        background-color: ${({ theme }) => theme.color.white};
        padding: 40px 60px;
        border-radius: 24px;

        & > h2 {
            width: 100%;
            font-family: bold;
            font-size: 16px;
            text-align: center;
        }
    `,

    "RadioDiv": styled.div`
        width: fit-content;
        display: flex;
        align-items: end;
        gap: 16px;
    `,
    "Radio": styled.button`
        font-size: 16px;
        padding: 8px 16px;
        border: 1px solid ${({ theme }) => theme.color.grey3};
        color: ${({ theme }) => theme.color.grey4};
        border-radius: 9999px;

        ${({ $select }) => $select && css`
            background-color: ${({ theme }) => theme.color.black};
            color: ${({ theme }) => theme.color.white};
        `}
    `,

    "ColorDiv": styled.div`
        display: flex;
        gap: 24px;
    `,
    "ColorElem": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;

        & > p {
            font-size: 16px;
        }
    `,

    "LogoSection": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;

        & > h3 {
            font-family: bold;
            font-size: 16px;
            text-align: center;
            margin: 0;
        }
    `,

    "LogoControls": styled.div`
        display: flex;
        gap: 20px;
        align-items: center;
    `,

    "LogoControl": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        & > label {
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.color.grey4};
        }

        & > input {
            width: 80px;
            padding: 8px 12px;
            border: 1px solid ${({ theme }) => theme.color.grey3};
            border-radius: 6px;
            font-size: 14px;
            text-align: center;

            &:focus {
                outline: none;
                border-color: ${({ theme }) => theme.color.black};
            }
        }
    `,

    "TransparencySection": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        width: 100%;
    `,

    "LogoPreview": styled.div`
        width: 280px;
        height: 276px;
        box-shadow: 0px 4px 8px 0px #0000004D;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 97px 8px;
        background-image: url(${transparencyBg});
        background-size: 280px 276px;
        background-repeat: no-repeat;

        & > img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            opacity: ${({ $opacity }) => $opacity / 100};
        }
    `,

    "TransparencyLabel": styled.p`
        font-size: 16px;
        font-weight: 400;
        margin: 0;
        color: #1F2024;
    `,

    "TransparencyControls": styled.div`
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        max-width: 280px;
    `,

    "TransparencySlider": styled.input`
        flex: 1;
        height: 16px;
        border-radius: 99px;
        background-image: url(${transparencyBg});
        background-size: 190px 120px;
        background-repeat: no-repeat;
        outline: none;
        -webkit-appearance: none;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
            border-radius: 99px;
            pointer-events: none;
        }

        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #F8F8F8;
            box-shadow: 0px 1px 4px 0px #0000005E;
            cursor: pointer;
            position: relative;
            z-index: 2;
        }

        &::-moz-range-thumb {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: ${({ theme }) => theme.color.white};
            cursor: pointer;
            border: none;
            position: relative;
            z-index: 2;
        }
    `,

    "TransparencyInputContainer": styled.div`
        position: relative;
        display: flex;
        align-items: center;
    `,

    "TransparencyInput": styled.input`
        width: 60px;
        padding: 8px 12px;
        border: 1px solid #B2B2B2;
        border-radius: 6px;
        font-size: 14px;
        text-align: center;

        &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.color.black};
        }
    `,

    "PercentSymbol": styled.span`
        position: absolute;
        right: 8px;
        font-size: 14px;
        color: #000000;
        pointer-events: none;
    `,

    "ButtonDiv": styled.div`
        display: flex;
        gap: 16px;
    `,
    "ApplyButton": styled.button`
        width: 100%;
        display: flex;
        justify-content: center;
        background-color: ${({ theme }) => theme.color.black};
        color: ${({ theme }) => theme.color.white};
        padding: 8px 0;
        border-radius: 6px;
        font-family: bold;

        ${({ $minor }) => $minor && css`
            background-color: ${({ theme }) => theme.color.grey2};
            color: ${({ theme }) => theme.color.black};
        `}
    `,

    "NavigationSection": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        width: 100%;

        & > h3 {
            font-family: bold;
            font-size: 16px;
            text-align: center;
            margin: 0;
        }
    `,

    "NavigationControl": styled.div`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
        max-width: 400px;

        & > label {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.color.grey4};
            cursor: pointer;

            & > input[type="checkbox"] {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }
    `
}

export default Style;
